import { SelecaoComFiltro } from "app/components/selecao-com-filtro/SelecaoComFiltro";
import { IFilial } from "app/types/IFilial";
import { DadosFilialOrcamento, DadosTrocarFilialOrcamento } from "app/types/TrocarFilialOrcamento";
import { FormikErrors, useFormik } from "formik";
import globalMU from "globalMU";
import React, { useEffect, useState } from "react"
import * as R from 'ramda';
import clsx from "clsx";

const estilosInputs = require('../../../estilos/inputs.module.scss').default
const estilosBotoes = require("../../../estilos/botoes.module.scss").default;

export type TrocarFilialOrcamentoProps = {
    dadosTrocarFilialOrcamento: Partial<DadosTrocarFilialOrcamento>
    filiais: IFilial[]
    pedirSenha: boolean
    processando: boolean
    ontrocarFilial: (dadosFilialOrcamento: Partial<DadosFilialOrcamento>) => void
    onPesquisarFiliais: (filial: string) => void
    onErrorValidacao: (erros: FormikErrors<DadosFilialOrcamento>) => void
    onValidarPermissao: (senha: string) => void
}

export const TrocarFilialOrcamento = (props: TrocarFilialOrcamentoProps) => {

    const [formularioValidado, setFormularioValidado] = useState<boolean>(false)
    const [carregandoFilial, setCarregandoFilial] = useState(false)

    useEffect(() => {
        setCarregandoFilial(false)
    }, [props.filiais])

    const formik = useFormik({
        initialValues: { ...props.dadosTrocarFilialOrcamento?.Dados },
        onSubmit: (values, { }) => { },
        enableReinitialize: true,
        validate: (values) => {

            const mensagemObrigatorio = (campo) => `O campo "${campo}" é obrigatório.`
            return R.pickBy(value => globalMU.isNotNullOrEmpty(value), {
                CodigoNovaFilial: globalMU.isNullOrEmptyOrZero(values.CodigoNovaFilial) ? mensagemObrigatorio("Nova Filial") : undefined,
            } as FormikErrors<DadosFilialOrcamento>)
        }
    });

    return (
        <>
            {props.pedirSenha &&
                <div className="_my-4">
                    <div className="_flex _items-center">
                        <label className={clsx(estilosInputs.labelObrigatorio, "_w-[160px] _text-right _font-normal _mb-0 _p-2")}>Senha</label>
                        <input type="text" 
                            id="TrocarFilialOrcamento_SenhaAutorizarTrocaFilial"
                            className={estilosInputs.inputPadrao} name="SenhaAutorizarTrocaFilial" value={(formik.values.SenhaAutorizarTrocaFilial) ?? ""} disabled={props.processando} />
                    </div>
                    <div className="_flex _items-center">
                        <label className={"_w-[160px] _text-right _font-normal _mb-0 _p-2"} />
                        <button className={`_flex no-global-button _mt-2 ${estilosBotoes.botaoPrimario}`}
                            disabled={props.processando}
                            id="TrocarFilialOrcamento_BotaoValidarSenha"
                            onClick={() => props.onValidarPermissao(formik.values.SenhaAutorizarTrocaFilial)}
                        >
                            Ok
                        </button>
                    </div>
                </div>
            }

            {!props.pedirSenha &&
                <div className="_my-4">
                    <div className="_flex _items-center">
                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Nº Orçamento</label>
                        <p className="_mb-0 _p-2"
                            id="TrocarFilialOrcamento_NumeroOrcamento"
                        >{props.dadosTrocarFilialOrcamento?.Dados?.Numero}</p>
                    </div>
                    <div className="_flex _items-center">
                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Situação</label>
                        <p className="_mb-0 _p-2">{props.dadosTrocarFilialOrcamento?.Dados?.DescricaoSituacao}</p>
                    </div>
                    <div className="_flex _items-center">
                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Cliente</label>
                        <p className="_mb-0 _p-2"
                            id="TrocarFilialOrcamento_Cliente"
                        >{props.dadosTrocarFilialOrcamento?.Dados?.NomeCliente}</p>
                    </div>
                    <div className="_flex _items-center">
                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Vendedor</label>
                        <p className="_mb-0 _p-2"
                            id="TrocarFilialOrcamento_Vendedor"
                        >{props.dadosTrocarFilialOrcamento?.Dados?.NomeVendedor}</p>
                    </div>
                    <div className="_flex _items-center">
                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Filial Original</label>
                        <p className="_mb-0 _p-2"
                            id="TrocarFilialOrcamento_FilialOriginal"
                        >{props.dadosTrocarFilialOrcamento?.Dados?.Filial}</p>
                    </div>
                    <div className="_flex _items-center">
                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Nova Filial</label>
                        <SelecaoComFiltro
                            classNameIconeSeta="_w-[10px] _text-gray-500 _mr-[4px]"
                            classNameInput={`_w-[300px] _mx-2 ${formularioValidado && formik.errors.CodigoNovaFilial != undefined && estilosInputs.inputComErro}`}
                            itens={carregandoFilial ? [{ chave: "", valor: "Buscando..." }] : (props.filiais ?? []).map(filial => ({
                                chave: filial.Codigo.toString(),
                                valor: filial.Descricao
                            }))}
                            onValorModificado={(filial) => (setCarregandoFilial(true), props.onPesquisarFiliais(filial))}
                            onItemSelecionado={item => {
                                formik.setFieldValue("CodigoNovaFilial", (props?.filiais ?? []).find(b => b.Codigo.toString() == item.chave)?.Codigo.toString())
                            }}
                            itemSelecionado={{
                                chave: formik.values.CodigoNovaFilial,
                                valor: (props?.filiais ?? []).find(b => b.Codigo.toString() == formik.values.CodigoNovaFilial)?.Descricao
                            }}
                            exibirIconeLimpar={false}
                            filtroManual={true}
                            disabled={props.processando}
                            id="TrocarFilialOrcamento_ComboFilial"
                            placeholder="Digite 1 ou mais caracteres"
                        />
                    </div>
                    <div className="_flex _items-center">
                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _px-2 _py-6" />
                        <button className={`_flex no-global-button _mx-2 _mt-2 ${estilosBotoes.botaoPrimario}`}
                            disabled={props.processando}
                            id="TrocarFilialOrcamento_BotaoTrocarFilial"
                            onClick={() => props.ontrocarFilial(formik.values)}>
                            {props.processando ? "Processando..." : "Trocar Filial"}
                        </button>
                    </div>
                    <section style={{ marginBottom: "100px" }} />
                </div>
                
            }
        </>
    )
}